import { addToReminders, removeFromReadingList, removeFromReminders, updateButtonState, updateEmptyPlaceholderVisibility } from "./reading-list-button"

import PerformantEvents from './performant-events'

import { LOCAL_STORAGE_KEY_READING_LIST_BOOKMARKS, LOCAL_STORAGE_KEY_READING_LIST_REMINDERS } from "./reading-list-button"

export default function init() {
  const toggle = document.querySelector('.js-toggle-reading-list')
  const readingList = document.querySelector('.js-reading-list-wrapper')
  const notificationEl = document.querySelector('.js-reading-list-notification')
  let scrolledUp = true

  if (notificationEl) {
    if (window.scrollY < 25) {
      notificationEl?.classList.add('scrolled-up')
    } else {
      notificationEl?.classList.remove('scrolled-up')
    }
  }

  PerformantEvents.onEvent('scroll', (position) => {
    if (scrolledUp && position > 25) {
      notificationEl?.classList.remove('scrolled-up')
      scrolledUp = false
    } else if (!scrolledUp && position <= 25) {
      notificationEl?.classList.add('scrolled-up')
      scrolledUp = true
    }
  });

  toggle.addEventListener('click', function (e) {
    e.preventDefault()

    if (readingList.classList.contains('active')) {
      closeReadingList()
    } else {
      openReadingList()
    }
  })

  notificationEl.addEventListener('click', function (e) {
    e.preventDefault()

    if (readingList.classList.contains('active')) {
      closeReadingList()
    } else {
      openReadingList()
    }
  })

  populateReadingList()

  updateEmptyPlaceholderVisibility()

  let hasStartedReading = false
  let hasFinishedReading = false

  if (document.querySelector('.js-entry-content-start')) {
    const startObserver = new IntersectionObserver((entries) => {
      if (hasStartedReading || hasFinishedReading) return
      const isIntersecting = entries[0]?.isIntersecting

      if (isIntersecting) {
        hasStartedReading = true
        const post = JSON.parse(document.querySelector('.js-entry-content-start').dataset.postData)
        setTimeout(() => {
          addToReminders(post)
        }, 100) // for cookiebot...
      }
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    })
    startObserver.observe(document.querySelector('.js-entry-content-start'))
  }

  if (document.querySelector('.js-entry-content-end')) {
    const endObserver = new IntersectionObserver((entries) => {
      if (!hasStartedReading || hasFinishedReading) return
      const isIntersecting = entries[0]?.isIntersecting

      if (isIntersecting) {
        console.log('finish reading')
        hasFinishedReading = true
        const post = JSON.parse(document.querySelector('.js-entry-content-end').dataset.postData)
        removeFromReminders(post)
      }
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    })
    endObserver.observe(document.querySelector('.js-entry-content-end'))
  }

  function populateReadingList() {
    const readingListSource = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_READING_LIST_BOOKMARKS)) || []
    const remindersSource = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_READING_LIST_REMINDERS)) || []

    const readingListContainer = document.querySelector('.js-reading-list')
    const ul = readingListContainer.getElementsByTagName('ul')[0]

    const remindersListContainer = document.querySelector('.js-reading-list-reminders')
    const remindersUl = remindersListContainer.getElementsByTagName('ul')[0]

    ul.innerHTML = '' // Clear list before populating

    // Populate reading list on load
    const readingListItems = readingListSource.map(item => {
      const listItem = `
        <li id="bookmark-${item.postId}" data-item='${JSON.stringify(item)}'>
          <button class="js-reading-list_delete-button delete-button">
            <span class="btn__icon icon icon-close"></span>
          </button>
          <a href="${item.permalink}">${item.title}</a>
        </li>
      `
      return listItem
    })
    ul.innerHTML = readingListItems.join('')

    remindersUl.innerHTML = '' // Clear list before populating

    // Populate reading list on load
    const reminderItems = remindersSource.map(item => {
      const listItem = `
        <li id="reminder-${item.postId}" data-item='${JSON.stringify(item)}'>
          <button class="js-reading-list_delete-button delete-button">
            <span class="btn__icon icon icon-close"></span>
          </button>
          <a href="${item.permalink}">${item.title}</a>
        </li>
      `
      return listItem
    })
    remindersUl.innerHTML = reminderItems.join('')

    // Add event listeners to delete buttons
    initDeleteButtons()
  }
}

export function initDeleteButtons () {
  for (const button of document.querySelectorAll('.js-reading-list-bookmarks .js-reading-list_delete-button')) {
    const post = JSON.parse(button.parentElement.dataset.item);

    button.addEventListener('click', (e) => handleDeleteButton(e, post))
  }

  for (const button of document.querySelectorAll('.js-reading-list-reminders .js-reading-list_delete-button')) {
    const post = JSON.parse(button.parentElement.dataset.item);

    button.addEventListener('click', (e) => {
      e.preventDefault()
      removeFromReminders(post)
    })
  }
}

function openReadingList() {
  const toggle = document.querySelector('.js-toggle-reading-list')
  const readingList = document.querySelector('.js-reading-list-wrapper')
  const hideables = document.querySelectorAll('.js-site-content, .js-main-footer')

  const toggleNav = document.querySelector('.js-toggle-main-navigation')
  const nav = document.querySelector('.js-main-navigation-wrapper')

  const toggleSearchBar = document.querySelector('.js-toggle-search-bar')
  const searchBar = document.querySelector('.js-search-bar-wrapper')

  const toggleLanguageSelector = document.querySelector('.js-toggle-language-selector')
  const languageSelector = document.querySelector('.js-language-selector__container-mobile')

  document.querySelector('.site-footer').style.display = 'none'

  hideables.forEach(hideable => hideable.style.display = 'none')

  toggle.classList.add('active')
  toggle.setAttribute('aria-expanded', true)
  readingList.classList.add('active')

  searchBar.classList.remove('active')
  toggleSearchBar.classList.remove('active')
  toggleSearchBar.setAttribute('aria-expanded', false)
  searchBar.style.display = 'none'

  toggleLanguageSelector.classList.remove('active')
  toggleLanguageSelector.setAttribute('aria-expanded', false)
  languageSelector.style.display = 'none'

  nav.classList.remove('active')
  toggleNav.classList.remove('active')
  toggleNav.setAttribute('aria-expanded', false)

  document.addEventListener('keyup', handleEscapeKey, { once: true })
}

export function closeReadingList() {
  const toggle = document.querySelector('.js-toggle-reading-list')
  const readingList = document.querySelector('.js-reading-list-wrapper')
  const hideables = document.querySelectorAll('.js-site-content, .js-main-footer')

  document.querySelector('.site-footer').style.display = 'block'
  hideables.forEach(hideable => hideable.style.display = 'block')
  toggle.classList.remove('active')
  toggle.setAttribute('aria-expanded', false)
  readingList.classList.remove('active')
  document.removeEventListener('keyup', closeReadingList)
}

// Handle deletion of posts from reading list local storage, reading list interface and update teaser button state
export function handleDeleteButton(e, post) {
  e.preventDefault()

  removeFromReadingList(post)
  updateButtonState()
}

function handleEscapeKey(e) {
  if (e.keyCode === 27) { // esc
    closeReadingList()
  }
}
